export default __webpack_public_path__ + "static/media/logo.646a44e2.svg";